const Paths = [
    "/dashboard",
    "/dashboard/:?fromPage&id",
    "/home",
    "/gallery",
    "/recordaudio",
    "/help",
    "/help/:getting",
    "/contactUs",
    "/addexpensetoreport",
    "/addexpensetoreport/:tripId",
    "/vendor",
    "/profile/adddelegation",
    "/expense",
    "/expense/addexpense",
    "/expense/addexpense/:tabId",
    "/expense/draft",
    "/expense/share",
    "/expense/split",
    "/expense/split/:txnId",
    "/expense/split/:txnId/:currency",
    "/expenses/dispute/:txnId",
    "/report",
    "/report/:reportTabs",
    "/report/:reportTabs/:viewId",
    "/report/:reportTabs/:viewId/:wallet",
    "/report/:tripId",
    "/automatedreport",
    "/automatedreport/:id",
    "/raisemoneyrequest/:wallet_id",
    "/travel",
    "/travel/:id",
    "/travel/:id/:tripId",
    "/travel/:id/:?fromPage",
    "/etl",
    "/etl/:id",
    "/cards",
    "/cards/:tabName",
    "/cardload_rq",
    "/recurring_load",
    "/genericworkflow",
    "/genericworkflow/:id",
    "/genericworkflow/:id/:resource_id",
    "/genericworkflow/:id/:resource_id/:editType",
    "/genericworkflow/:id/:resource_id/:editType/:fromOthersTab",
    "/deleted_user",
    "/bulk_history",
    "/bulk",
    "/bulk/:mId",
    "/bulk/:mId/:oId",
    "/bulk/:mId/:oId/:stepId",
    "/bulkNew",
    "/bulkNew/:mId",
    "/bulkNew/:mId/:oId",
    "/bulkexpense",
    "/bulkexpense/:mId",
    "/bulkexpense/:mId/:oId",
    "/bulkexpense/:mId/:oId/:stepId",
    "/bulkapprove",
    "/bulkapprove/:id",
    "/bookings",
    "/bookings/:type",
    "/bookings/:type/:it_id",
    "/autocontaineraction",
    "/autocontaineractionV2",
    "/reporttripdetails",
    "/testUI",
    "/initiatesingle",
    "/initiatesingle/:identifier",
    "/initiatesingle/:identifier/:amount",
    "/initiatesingle/:identifier/:amount/:userId",
    "/initiatesingle/:identifier/:amount/:userId/:walletType",
    "/initiatesingle/:identifier/:amount/:userId/:walletType/:initiatMode",
    "/initiate_wallet_load",
    "/initiate_wallet_load/:no_of_users",
    "/initiate_wallet_load/:no_of_users/:totalUsers",
    "/initiate_wallet_load/:no_of_users/:totalUsers/:walletValue",
    "/initiate_wallet_withdraw",
    "/initiate_wallet_withdraw/:no_of_users",
    "/initiate_wallet_withdraw/:no_of_users/:totalUsers",
    "/initiate_wallet_withdraw/:no_of_users/:totalUsers/:walletValue",
    "/containertype",
    "/containertype/:ct_id",
    "/containertype/:ct_id/:efId",
    "/createrecurringload",
    "/createrecurringload/:id",
    "/appcenter",
    "/appcenter/userconfig",
    "/appcenter/userconfig/:stp_id",
    "/wallets",
    "/wallets/:walletTab",
    "/wallets/:walletTab/:walletSubTab",
    "/wallets/:walletTab/:walletSubTab/:mId",
    "/moneyrequest",
    "/banktransfer/initiate",
    "/bulk/update/bulkSettlement",
    "/budget",
    "/budget/:budgetTab",
    "/budget/:budgetTab/:id",
    "/currencyrateoperation",
    "/currencyrateoperation/:crOperation",
    "/currencyrateoperation/:crOperation/:id",
    "/poolAccount/loadWallet",
    "/recurringtransferadd",
    "/recurringtransferadd/:id",
    "/passbook",
    "/walletcontrol",
    "/walletcontrol:?fromPage&id",
    "/settlements",
    "/currency",
    "/invoice",
    "/poolAccount",
    "/orgAccount",
    "/budget", // How to navigate this from UI?
    "/banktransfer",
    "/recurringtransfer",
    "/settlementEmployeeTabs/*",
    "/settlementTabs/*",
    "/currencyrates",
    "/currencyrates/:component",
    "/profile/*",
    "/profile/constructCurrencyRange", // not able to test this path, getting some permission issue
    "/profile/constructCurrencyRange(:/id)", // I think this route is also wrong
    "/users",
    "/users/:id",
    "/users/:id/*",
    "/users/:id/wallets/*",
    "/user/:userTabs",
    "/user/:userTabs/:stp_id",
    "/user/:userTabs/:stp_id/:type",
    "/history/moneyrequest",
    "/cardload_hist",
    "/pending/moneyrequest",
    "/pending/cardload",
    "/others/allmoneyrequest",
    "/history/travel",
    "/pending/travel",
    "/others/alltravel",
    "/history/report",
    "/pending/report",
    "/others/allreport",
    "/vehicleList",
    "/vehicleCardLimit",
    "/vehicleList/addNewVehicles",
    "/vehicleList/editVehicle",
    "/vehicleCardLimit/vehiclesCurrentLimit",
    "/recharge",
    "/recharge/:rechargeTab",
    "/analytics",
    "/analytics/*",
    "/analytics/mydashboard",
    "/analytics/:tab",
    "/account",
    "/administration",
    "/administration/categories",
    "/administration/:administrationTabs",
    "/administration/:administrationTabs/:eId",
    "/administration/:administrationTabs/:eId/:aId",
    "/administration/:administrationTabs/:eId/:aId/:sId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId",
    "/administration/:administrationTabs/:eId/:aId/:sId/:sid/:nid/:mId/:pId/:qId/:lId/:kId/:cId/:rId",
    "/xpendite",
    "/xpendite/smartemail",
    "/xpendite/scanx",
    "/xpendite/uber",
    "/xpendite/whatsapp",
    "/xpendite/smartforwards",
    "/xpendite/smartsms",
    "/bulkBudget",
    "/atmLocator"
];

export default Paths;
